import { render, staticRenderFns } from "./accountSettings.vue?vue&type=template&id=21557b6b&scoped=true&"
import script from "./accountSettings.vue?vue&type=script&lang=js&"
export * from "./accountSettings.vue?vue&type=script&lang=js&"
import style0 from "./accountSettings.vue?vue&type=style&index=0&id=21557b6b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21557b6b",
  null
  
)

export default component.exports